import { Table } from '@rd-web-markets/shared/dist/util';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleVerticalChevronButton } from '@rd-web-markets/shared/dist/util/buttons/ToggleVerticalChevronButton';
import companyProjectsService from '../../services/company/all_projects_with_missions.service';
import ProjectNestedData from './ProjectNestedData';
export default function ProjectsTab(_ref) {
  let {
    companyId
  } = _ref;
  const [companyProjects, setCompanyProjects] = companyProjectsService.useFetchCompanyProjects(companyId);
  const {
    t
  } = useTranslation();
  const toggleExpandProjectCrossClaimGroup = useCallback((index, isExpanded) => {
    companyProjects[index].expanded = isExpanded;
    setCompanyProjects([...companyProjects]);
  }, [companyProjects, setCompanyProjects]);
  const buildRows = companyProjects => {
    const rows = companyProjects.map((companyProject, index) => ({
      key: companyProject.id,
      columns: [companyProject.project_name, companyProject.lifetime_of_the_customer_project_from, companyProject.lifetime_of_the_customer_project_to, /*#__PURE__*/React.createElement(ToggleVerticalChevronButton, {
        expanded: !!companyProject.expanded,
        onClick: () => toggleExpandProjectCrossClaimGroup(index, !companyProject.expanded)
      })],
      expandable: true,
      expanded: !!companyProject.expanded,
      renderExpandedContent: () => /*#__PURE__*/React.createElement(ProjectNestedData, {
        project: companyProject,
        projectClaimGroups: companyProject.same_year_claim_groups
      })
    }));
    return rows;
  };
  const headers = useMemo(() => [{
    text: t('project_name')
  }, {
    text: t('start_date')
  }, {
    text: t('end_date')
  }, {
    text: t('expand')
  }], [t]);
  if (!(companyProjects !== null && companyProjects !== void 0 && companyProjects.length)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      overflowX: 'auto',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: '1600px',
      overflowX: 'auto'
    }
  }, /*#__PURE__*/React.createElement("style", null, "\n            .ProjectsTab-Tab-table-header {\n              word-break: break-word;\n            }\n          "), /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: buildRows(companyProjects),
    opts: {
      headerClass: 'ProjectsTab-Tab-table-header'
    }
  })));
}